(function HotelEngineRateBadge($, Adzuki)
{
	'use strict';

	const component = {
		emits: ['rate-key'],
		props: {
			sabreHotelId: {
				type    : String,
				required: true,
			},
			rateCodes: {
				type: Array,
			},
			collections: {
				type: Array,
			},
			style: {
				type   : String,
				default: 'badge'
			}
		},
		template: `
			<div class="rate-badge-container">
				<template v-for="(srCode, index) in rateCodes">
					<a
						v-if="style === 'badge'"
						class="label"
						:class="['label-'+labelMarker(srCode)+'', 'rate-badge']"
						@click.prevent="getRateDetails(srCode)"
					>
						{{ displaySpecialtyRateCode(srCode) }}
					</a>
					<a v-else @click.prevent="getRateDetails(srCode)">{{ displaySpecialtyRateCode(srCode) }}</a>
				</template>
				<span
					v-for="collection in collections"
					class="label label-primary pointer margin5-left pointer"
				>
					{{ collection.name }}
				</span>
				<div v-if="showBadgeModal">
					<adzuki-modal
						:modal-title="rateDetails.description"
						:type="'component'"
						:component-name="componentToRender"
						:component-props="rateDetailProps"
						@close-modal="closeModal"
					></adzuki-modal>
				</div>
			</div>
		`,
		data() {
			return {
				baseUri          : Adzuki.base_uri,
				selectedRate     : {},
				rateDetails      : {},
				showBadgeModal   : false,
				componentToRender: '',
				rateDetailProps  : ''
			};
		},
		computed: {
		},
		methods: {
			displaySpecialtyRateCode(code) {
				return Adzuki.HotelEngine.displaySpecialtyRateCode(code);
			},
			resolveSpecialtyRateCode(code) {
				return Adzuki.HotelEngine.resolveSpecialtyRateCode(code);
			},
			async getRateDetails(rateKey) {
				const searchCriteria = JSON.parse(sessionStorage.getItem('searchCriteria'));
				const formData = new FormData();
				const rateCode = this.resolveSpecialtyRateCode(rateKey);

				formData.append('sabre_hotel_id', this.sabreHotelId);
				formData.append('check_in', searchCriteria.check_in);
				formData.append('check_out', searchCriteria.check_out);
				formData.append('rate_code', rateCode);


				const response = await fetch(this.baseUri + '/HotelEngine/loadSpecialtyRateDetails', {
					method: 'POST',
					body  : formData,
				});

				if (!response.ok) {
					throw new Error(`Error fetching details: ${response.statusText}`);
				}

				this.rateDetails = await response.json();

				if (this.rateDetails) {
					this.rateDetailProps = {
						rateDetails: this.rateDetails,
					};
					this.componentToRender = Vue.markRaw(Adzuki.VueComponents.HotelEngineRateDetails);
					this.showBadgeModal = true;
				}

			},
			labelMarker(code) {
				let label;
				switch (this.resolveSpecialtyRateCode(code)) {
					case 'GCD':
					case 'THC':
						label = 'success';
						break;
					case 'FHR':
						label = 'info';
						break;
					case 'SIG':
						label = 'danger';
						break;
					case 'SGP':
						label = 'warning';
						break;
					default:
						label = 'primary';
						break;
				}
				return label;
			},
			closeModal() {
				this.showBadgeModal = false;
			}
		},
		watch: {
		}
	};

	Adzuki.VueComponents.HotelEngineRateBadge = component;
}(jQuery, window.Adzuki || {}));
